const breakPoints = {
	Mobile: {
		name: "Mobile",
		id: "Mobile",
		icon: '<span class="icon-mobile-phone"></span>',
		min: 0,
		max: 767,
	},
	Tablet: {
		name: "Tablet",
		id: "Tablet",
		icon: '<span class="icon-tablet"></span>',
		min: 768,
		max: 991,
	},
	Desktop: {
		name: "Desktop",
		id: "Desktop",
		icon: '<span class="icon-desktop"></span>',
		min: 992,
		max: 1280,
	},
};

export default breakPoints;
